import React from 'react';
import { Box, Pagination as MuiPagination, Typography } from '@mui/material';

const Pagination = ({ 
  page, 
  totalPages, 
  totalItems, 
  pageSize, 
  onChange,
  sx = {}
}) => {
  const startItem = totalItems === 0 ? 0 : ((page - 1) * pageSize) + 1;
  const endItem = Math.min(page * pageSize, totalItems);

  if (totalPages <= 1) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 3, ...sx }}>
      <MuiPagination
        count={totalPages}
        page={page}
        onChange={(event, value) => onChange(value)}
        color="primary"
        sx={{
          mb: 1,
          '& .MuiPaginationItem-root': {
            color: '#000000',
          },
          '& .Mui-selected': {
            backgroundColor: '#000000',
            color: '#FFFFFF',
            '&:hover': {
              backgroundColor: '#333333',
            },
          },
        }}
      />
      {totalItems > 0 && (
        <Typography variant="body2" color="text.secondary">
          Showing {startItem} - {endItem} of {totalItems}
        </Typography>
      )}
    </Box>
  );
};

export default Pagination;
